import React, { Component } from "react";
import HeaderPage from "../projectmgmt/header/Header";
import StsLeftPanel from "./StsLeftPanel";

class StsMainPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: "#F9F9FB" }}>
        {/* Navbar */}
        <div id="navBar">
          <HeaderPage />
        </div>
        {/* Left panel */}
        <div className="content-wrapper" id="leftPanel">
          <StsLeftPanel />
        </div>
      </div>
    );
  }
}

export default StsMainPage;



// WEBPACK FOOTER //
// ./src/stsUi/StsMainPage.js